<template>
    <div>
        <!-- Sidebar that display when User in Move Mode  -->
        <sidebar-menu
                :menu="menu"
                @collapse="onCollapse"
                :collapsed="isSideBarExpanded"
                @item-click="onItemClick"
        />
    </div>
</template>

<script>
import { SweetModal } from 'sweet-modal-vue';

import { RepositoryFactory } from '../../../../../../repositories/RepositoryFactory';

export default {
  name: 'SideBarInMoveMode',
  computed: {
    isSideBarExpanded() {
      return this.$store.getters.isSidebarExpanded;
    },
  },
  methods: {
    onCollapse(collapsed) {
      this.$store.dispatch('expandSidebar', collapsed);
    },
    onItemClick(event, item) {
    	if (item.id === 'moveDisable') {
		    this.disableModeMode();
      }
    },

    /*
        ======= ACTIONS =======
      */

    /**
       * Disables the move mode which allows users to move chapters & entries
       */
    disableModeMode() {
      this.$store.commit('setChapterEntryMode', 'default');
    },


    /*
      == MENU ==
     */
    menu() {
    	return {
		    title: this.$t('UI_INSTANCE_FAB_MENU_MOVE_DISABLE'),
		    icon: 'fa fa-times',
		    id: 'moveDisable',
	    };
    },
  },
  data() {
    return {
      menu: [
        {
          title: this.$t('UI_INSTANCE_FAB_MENU_MOVE_DISABLE'),
          icon: 'fa fa-times',
          id: 'moveDisable',
        },
      ],

    };
  },
};
</script>

<style scoped>

</style>
